export const PAGE_NAMES = {
  ACTIVE_OTT: 'Active OTT',
  ACTIVITY_FEED: 'Activity Feed',
  ADCOPY_AI: 'AdCopy AI',
  AGENT_ORDER_APPROVALS: 'Agent Order Approvals',
  AGENT_PLAN_BUY: 'Plan & Buy Agent',
  AMC_INSIGHTS: 'AMC Insights',
  AMC_INSTANCES: 'AMC Instances',
  ANOMALY_DETECTION: 'Automated Alerting',
  AUDIT_PORTFOLIO: 'Audit Portfolio',
  AUDIENCE_PLANNER: 'Audience & Planner',
  BATCH_FAILURES: 'Batch Failures',
  BENCHMARKING: 'Benchmarking',
  BILLING_AUTOMATION: 'Billing Automation',
  BRAND_EQUITY: 'Brand Equity',
  BRAND_HEALTH_METRICS: 'Brand Health Metrics',
  CALENDAR: 'Calendar',
  CALENDAR_INPUTS: 'Calendar Inputs',
  CAMPAIGN_AUDIT: 'TVAD Campaign Audit',
  CATEGORY_PATHING: 'Category Pathing (Demo)',
  CHARTS: 'Charts',
  CLIENT_DATA_MAPPING: 'Client Data Mapping',
  CLIENT_PROFITABILITY_SURVEY: 'Client Profitability Survey',
  COMMERCE_MMM: 'Commerce MMM',
  COMMERCE_SCRAPER: 'Commerce Scraper',
  COMPANIES: 'Companies',
  CREATIVE_INSIGHTS: 'Linear Creative Insights',
  CRO_ONBOARD: 'CRO Onboard',
  CROSS_CHANNEL: 'Cross-Channel',
  CROSS_CLIENT_ORACLE_CHAT: 'Cross-Client Oracle Chat',
  CUSTOMER_INSIGHTS: 'Customer Insights',
  DASHBOARD: 'Dashboard',
  DASHBOARDS: 'Dashboards',
  DIGITAL_AUDIT: 'Digital Audit',
  DISPLAY_PACING: 'Display Pacing',
  DTC_MMM: 'DTC MMM',
  ELEVATE_DEMO: 'Elevate Demo',
  FEED_MANAGEMENT: 'Feed Management',
  FORECASTING: 'Forecasting',
  GEO_MMM: 'Geo MMM',
  GEO_MMM_NEW: 'Geo MMM (New)',
  GLOBAL_BENCHMARKING: 'Global Benchmarking',
  GOAL_INTAKE: 'Goal Intake Tool',
  GOAL_INTAKE_NEW: 'Goal Intake (new)',
  GOOGLE_ADS_AUDIT: 'Google Ads Audit',
  IMAGE_UPLOADER: 'Image Uploader',
  INCREMENTALITY_PLAYBOOK: 'Incrementality Playbook',
  INSIGHTS_AGENT: 'Insights Agent',
  INVOICING: 'Invoicing',
  KPI_MAPPING: 'KPI Mapping',
  KPI_STATUS: 'KPI Status',
  LINEAR_CONSTRAINTS: 'Linear Global Constraints',
  LINEAR_NETWORKS: 'Linear Networks',
  LINEAR_ORDERS: 'Linear Orders',
  LINEAR_PACING: 'Linear Pacing',
  LINEAR_PLANS: 'Linear Plans',
  LOGS_TRACKER: 'Logs Tracker',
  META_HACKATHON: 'Meta Hackathon',
  MMM_DATA_QA: 'MMM Data QA',
  MMM_FAQ: 'MMM FAQ',
  MMM_FEATURE_MAPPING: 'MMM Feature Mapping',
  ORACLE_CHAT: 'Oracle Chat',
  ORACLE_CLIENT_CONFIG: 'Client Oracle Configuration',
  PACING: 'Pacing',
  PAGE_NOT_FOUND: 'Page Not Found',
  REFERENCE_DOCS: 'Reference Docs',
  SCALING: 'Scaling',
  SEGMENTATION_MAPPING: 'Segmentation Mapping',
  SITE_MONITORING: 'Site Monitoring',
  SLIDE_GENERATOR: 'Slide Generator',
  SOT_GA4_MAPPING_TOOL: 'SOT/GA4 Mapping Tool',
  SPIKE_CHART: 'Spike Chart',
  STREAMING_BUYING: 'Streaming Buying',
  STREAMING_CONSTRAINTS: 'Streaming Global Constraints',
  STREAMING_CREATIVES: 'Streaming Creatives',
  STREAMING_FLIGHT_PLAN: 'Streaming Flight Plan',
  STREAMING_MEDIA_PLANNER: 'Streaming Plans Builder',
  STREAMING_NETWORKS: 'Streaming Networks',
  STREAMING_ORDER_STATUS: 'Streaming Order Status',
  STREAMING_PACING: 'Streaming Pacing',
  STREAMING_REPORTS: 'Streaming Reports',
  USER_ADMIN: 'User Admin',
  YOUTUBE_PLANNING: 'YouTube Planning'
} as const;
export type PageType = (typeof PAGE_NAMES)[keyof typeof PAGE_NAMES];

export const PAGE_EMPTY_COPY = {
  title: 'Nothing to show yet',
  description: 'There is no data for the current selection.'
};

export const PAGE_STATE = {
  LOADING: 'loading',
  EMPTY: 'empty'
} as const;
export type PageState = (typeof PAGE_STATE)[keyof typeof PAGE_STATE];
